import { useIntl } from 'react-intl';
import { useRecoilCallback } from 'recoil';
import { connectorViewerOpenPhaseState } from '~/state/atoms/dicomProcessorAtoms';
import { enqueueSnackbar } from '~/utils/notifications';

/**
 * Exclusive-feed guard for the shared DicomProcessor: returns a callback that
 * warns the user and reports `true` when the input must be refused.
 *
 * The phase is read from a snapshot at call time, not subscribed to: callers
 * park this in callbacks that outlive their render (a job's stored `onLoad`),
 * where a captured phase would report the state at capture time.
 */
export function useRefuseWhileViewerOpening(): () => boolean {
    const intl = useIntl();

    return useRecoilCallback(
        ({ snapshot }) =>
            (): boolean => {
                const phase = snapshot
                    .getLoadable(connectorViewerOpenPhaseState)
                    .getValue();
                if (phase === 'idle') {
                    return false;
                }
                enqueueSnackbar(
                    intl.formatMessage({ id: 'patientList.open.inFlight' }),
                    { variant: 'warning' }
                );
                return true;
            },
        [intl]
    );
}
